<script setup lang="ts">
import { useFavicon, usePreferredDark } from "@vueuse/core";
import { ConfirmDialog } from "primevue";
import { computed } from "vue";
import { RouterView, useRoute } from "vue-router";

const route = useRoute();
const isAdmin = computed(() => route.path.startsWith("/admin"));
const isDark = usePreferredDark();
const faviconPath = computed(() => (isDark.value ? "/favicon-dark.ico" : "/favicon.ico"));
useFavicon(faviconPath);
</script>

<template>
  <div :class="{ 'app-area': !isAdmin, 'admin-area': isAdmin }">
    <RouterView />

    <ConfirmDialog />
  </div>
</template>

<style lang="scss">
.app-area {
  font-size: 16px;
}

.admin-area {
  font-size: 14px;
}

:root {
  --sat: env(safe-area-inset-top);
  --sar: env(safe-area-inset-right);
  --sab: env(safe-area-inset-bottom);
  --sal: env(safe-area-inset-left);
}

.safe-area-bot {
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
